export default {"src":"/_next/static/media/skills.206ad9ea.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};